import {Component, Input, OnInit} from '@angular/core';
import {DsDropdownComponent} from "../../../../shared/components/ds-dropdown/ds-dropdown.component";
import {IDsDropdownOption} from "../../../../shared/components/ds-dropdown/ds-dropdown-option";
import {NgChartsModule} from "ng2-charts";
import {filter, first, switchMap} from "rxjs/operators";
import {Store} from "@ngrx/store";
import * as fromStore from "../../../../store";
import {format, subDays} from 'date-fns';
import {DatePipe} from "@angular/common";
import {Utils} from "../../../../shared/utils/utils";
import {DbTextPipe} from "../../../../shared/pipes/db-text.pipe";
import {TextUtils} from "../../../../shared/utils/text-utils";

@Component({
    selector: 'db-visits-widget',
    templateUrl: './visits-widget.component.html',
    imports: [
        DsDropdownComponent,
        NgChartsModule,
        DatePipe,
        DbTextPipe
    ],
    styleUrl: './visits-widget.component.scss'
})
export class VisitsWidgetComponent implements OnInit {
    visits = [];
    @Input() website;
    @Input() demoUser: boolean;
    dropdownOptions: IDsDropdownOption[] = [
        {
            label: TextUtils.getText('text_lastDays'),
            value: '7days'
        },
        {
            label: TextUtils.getText('text_last30Days'),
            value: '30days'
        },
    ];
    activeMode = '7days';
    usedHostingVisitsByWebsite: any;
    maxVisitors: number = null;
    mostVisitorsDayId = null;
    hoveredDayId = null;
    hasVisitors = true;
    sumByDate = 0;
    roundNumbers = Utils.countToString;

    constructor(private _store: Store<fromStore.DbStoreState>, ) {
    }

    days = [];
    endDate = subDays(new Date(), 7);
    startDate = new Date();

    ngOnInit() {
        this._store.dispatch(new fromStore.LoadHostingVisitsByWebsiteByDate({websiteId: this.website.id, date: null}));
        this._store.dispatch(new fromStore.LoadHostingResourcesByWebsite(this.website.id));
        this._store.select(fromStore.getHostingVisitsByWebsiteByDateLoaded(this.website.id))
            .pipe(
                filter((loaded: boolean): boolean => loaded),
                switchMap(() => this._store.select(fromStore.getHostingVisitsByWebsiteByDateMap(this.website.id))),
                first()
            )
            .subscribe((visitsMap: any) => {
                console.log(visitsMap);
                const visits: any = visitsMap && visitsMap.entities;
                if (visits) {
                    this.maxVisitors = Math.max(...visitsMap.entities.data.map(d => d.count));
                    this.visits = visitsMap.entities.data;
                    this.usedHostingVisitsByWebsite = visits.sum;
                    this.days = this.getLastNDaysFilled(this.visits, 7);
                    const mostVisitedDay = this._getMostVisitorsDayId();
                    this.mostVisitorsDayId = mostVisitedDay.id;
                    this.hasVisitors = mostVisitedDay.count !== 0;
                    this.sumByDate = this._getSum(this.days);
                }
            });
    }

    private _getSum(days: { count: number; id: number; date: string }[]) {
        return days.reduce((sum, day) => sum + day.count, 0);
    }

    daysChanged(value: IDsDropdownOption['value']) {
        this.activeMode = value as string;
        if (value === '7days') {
            this.days = this.getLastNDaysFilled(this.visits, 7);
            this.endDate = subDays(new Date(), 7);
            return;
        }
        this.days = this.getLastNDaysFilled(this.visits, 30);
        this.endDate = subDays(new Date(), 30);
        const mostVisitedDay = this._getMostVisitorsDayId();
        this.mostVisitorsDayId = mostVisitedDay.id;
        this.hasVisitors = mostVisitedDay.count !== 0;
        this.sumByDate = this._getSum(this.days);
    }

    getLastNDaysFilled(
        data: { count: number; date: string; }[],
        days: number
    ): { count: number; date: string; id: number }[] {
        const result: { count: number; date: string; id: number }[] = [];
        const today = new Date();
        const dataMap = new Map(data.map(d => [d.date, d.count]));

        for (let i = days - 1; i >= 0; i--) {
            const date = subDays(today, i);
            const dateStr = format(date, 'yyyy-MM-dd');
            result.push({
                id: i,
                date: dateStr,
                count: dataMap.get(dateStr) ?? 0,
            });
        }

        return result;
    }

    private _getMostVisitorsDayId(): { id: number; date: string; count: number; } {
        return this.days.reduce((max, curr) => {
            return curr.count > max.count ? curr : max;
        }, this.days[0]);
    }


    getHeightPercent(visitors: any) {
        const minPercent = (7 / 140) * 100; // 5% of new max
        if (this.maxVisitors === 0) return minPercent;

        const heightPercent = (visitors / this.maxVisitors) * 100;
        return Math.max(heightPercent, minPercent);
    }

}
